import { onViewAllMenuClicked, onSearchTextChanged } from '../actions/internalActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';

// show all folders
mutator(onViewAllMenuClicked, () => {
    getStore().shouldShowAllFolders = true;
});

mutator(onSearchTextChanged, actionMessage => {
    const moveToStore = getStore();
    // Only if we are in Primary mbx mode we will reset shouldShowAllFolders
    // In IE11, focusing on the search box on first mount fires this action.
    // We need an additional check to ensure the store only updates when text is added or removed
    if (
        moveToStore.moveToMailboxType === 'UserMailbox' &&
        actionMessage.currentSearchText !== actionMessage.newSearchText
    ) {
        // if search text is not empty then all folders should be shown, else default view will be shown
        moveToStore.shouldShowAllFolders = actionMessage.newSearchText.length > 0;
    }
});
